// Utils
import {
  addImageryLayer,
  loadTMSWithColor,
  changeImageryLayerOpacityByName,
  removeImageryLayerByName
} from "utils/Cesium/CesiumImageryUtils";

// Services
import { getPalette } from "services/layer";

// Other
import { resistanceLayerName } from "assets/global";

export async function cesiumAddResistanceMap(viewer, resistanceMap, opacity) {
  const paletteType =
    resistanceMap.ui_settings && resistanceMap.ui_settings["palette"]
      ? resistanceMap.ui_settings["palette"]
      : "RM_YBR";
  const palette = await getPalette(paletteType);

  let layerName = resistanceLayerName + resistanceMap.id;
  if (resistanceMap.tms_tiles) {
    // Load Tile Map Service
    const payload = {
      layerId: resistanceMap.id,
      viewer: viewer,
      gradient: palette,
      tmsUrl: resistanceMap.tms_tiles,
      name: layerName,
      color: null,
      source: "resistanceMap",
      alpha: opacity
    };
    loadTMSWithColor(payload);
  } else {
    addImageryLayer(viewer, layerName, resistanceMap, opacity);
  }
}

export function cesiumRemoveResistanceMap(viewer, resistanceMapId) {
  removeImageryLayerByName(viewer, resistanceLayerName + resistanceMapId);
}

export function cesiumSetResistanceMapOpacity(viewer, resistanceMap, opacity) {
  changeImageryLayerOpacityByName(
    viewer,
    resistanceLayerName + resistanceMap.id,
    opacity
  );
}

export function cesiumClearAllResistanceMaps(viewer) {
  removeImageryLayerByName(viewer, resistanceLayerName);
}
